module.exports = __webpack_public_path__ + "static/media/Bee Colony Losses.3eac3486.mp4";